import React from 'react'

const BankTopup = () => {
  return (
    <div className="">
      <div className="bg-white p-4 rounded-lg w-full lg:w-1/2">
        <div className='text-center space-y-2'>
          <h3>Kindly top up using equity account number</h3>
          <h3 className='text-[#134463]'><b>1080279803226</b></h3>
          <h3>and share details to finance@mawinguairtime.com</h3>
          <h3>For any enquiries call <span className='text-[#134463]'><b>0712548371</b></span></h3>
        </div>
      </div>
    </div>

  )
}

export default BankTopup
